module.exports = __webpack_public_path__ + "static/media/x-icon-yellow.6de23b94.svg";